var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 36,
    viewBox: "0 0 40 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4521 8.04948L15.8281 14.7204L1.2041 8.04948L15.8281 1.37761L30.4521 8.04948Z",
    fill: "#00B074",
    stroke: "#E7E7E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.006 10.9965L22.2531 11.8031L7.63879 5.1088L9.40149 4.32364L24.006 10.9965Z",
    fill: "#F7C604",
    stroke: "#E7E7E7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3291 15.5917V34.3934L0.5 27.6278V8.82703L15.3291 15.5917Z",
    fill: "#0A5239",
    stroke: "#E7E7E7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1581 27.6278L16.329 34.3934V15.5917L31.1581 8.82703V27.6278Z",
    fill: "#00D68D",
    stroke: "#E7E7E7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M30.2335 18.5433C30.5513 18.5434 30.8564 18.57 31.1583 18.6224V27.6283L25.2305 30.3344C24.3317 29.1056 23.7902 27.5194 23.7901 25.7845C23.7901 21.7334 26.7252 18.5433 30.2335 18.5433Z",
    fill: "#0C1E5B",
    stroke: "#E7E7E7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.707 19.0221L22.7539 19.9205V12.6734L24.707 11.775V19.0221Z",
    fill: "#F7C604",
    stroke: "#E7E7E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0574 17.9656C36.5658 17.9658 39.4998 21.1555 39.4998 25.2068C39.4995 29.258 36.5657 32.4469 33.0574 32.4471C29.5489 32.4471 26.6142 29.2581 26.614 25.2068C26.614 21.1554 29.5488 17.9656 33.0574 17.9656Z",
    fill: "#FF5B5B",
    stroke: "#E7E7E7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9941 22.9047C36.0401 22.9047 36.0938 22.9227 36.1425 22.9819L36.1494 22.9906L36.1562 22.9985C36.3045 23.1638 36.2837 23.4124 36.1708 23.5278L36.164 23.5356L36.1562 23.5444L32.5038 27.6166C32.4304 27.6985 32.3788 27.7103 32.332 27.7104C32.2967 27.7104 32.2587 27.7036 32.2109 27.6655L32.1601 27.6166L29.9579 25.1615C29.8097 24.9962 29.8305 24.7477 29.9433 24.6322L29.9501 24.6244L29.9579 24.6156C30.0238 24.5423 30.0919 24.5219 30.1396 24.5219C30.1856 24.5219 30.2384 24.5408 30.287 24.6L30.2939 24.6078L30.3017 24.6156L31.9599 26.4643L32.332 26.8793L32.704 26.4643L35.8124 22.9985C35.8782 22.9251 35.9464 22.9048 35.9941 22.9047Z",
    fill: "white",
    stroke: "#E7E7E7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M3.19434 23.798L2.91504 23.6603L2.55176 23.4816L3.32031 22.3624L4.14941 24.2657L3.61914 24.0235V26.5587L3.19434 26.3429V23.798Z",
    fill: "#F2F5F3",
    stroke: "#E7E7E7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/Box.54f9afa8cf81ac7dd1ca53a1e8db37cd.svg";
export { ForwardRef as ReactComponent };